import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolmanagementService } from '../services/schoolmanagement.service';
import { UseraccessserviceService } from '../services/useraccessservice.service';
import { UtilService } from '../services/util.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(private util: UtilService, private router: Router, private schoolmanager: SchoolmanagementService, private useraccessservice: UseraccessserviceService, private activatedroute: ActivatedRoute) { }

  async ngOnInit() {
    //debugger;
    // ?token= is the cross-subdomain sign-on handoff. The public site's "Enter School"
    // button (impatasite school-card.component.ts:21) and the school switcher both land
    // here with a freshly exchanged token; the origins differ, so localStorage cannot
    // carry it and the query string is the only channel. Do not remove this.
    // Every redirect below uses replaceUrl so the token-bearing entry does not stay in
    // browser history once it has been consumed.
    if(this.activatedroute.snapshot.queryParams.token){
      this.useraccessservice.setAuthenticatedUserToken(this.activatedroute.snapshot.queryParams.token);
    }

      //const currentUserToken = this.useraccessservice.getCurrentUserToken();
      // let user;
      // //if(currentUserToken){
      //   user = await this.useraccessservice.isAlive().toPromise().catch(() => {
      //     user = null;
      //   });
      //}
      if(this.useraccessservice.getCurrentUserToken()){//if there is a user logged in
        //go to my courses
        //if you are a admin, go to the school page
        //if you have courses, go to the dashboard
        //else, go to the school page

        //let callerIsAdmin;
        //let studentHasCourses;
        //let tutorHasCourses;
      //   [callerIsAdmin/*, studentHasCourses, tutorHasCourses*/] = await Promise.all([this.util.checkUserIsSubdomainAdmin().toPromise()/*, 
      //                                                           this.util.checkStudentHasCourses().toPromise<boolean>(),
      // this.util.checkTutorHasCourses().toPromise<boolean>()*/]);

      //   if(callerIsAdmin){
      //     this.router.navigate(['/user/schoolhome']);
      //   }
      //   // else if(studentHasCourses || tutorHasCourses) {
      //   //   this.router.navigate(['/user/dashboard']);
      //   // }
      //   else{
      //     this.router.navigate(['/user/dashboard']);
      //   }     

        if (this.activatedroute.snapshot.queryParams.url) {
          this.router.navigateByUrl(this.activatedroute.snapshot.queryParams.url, { replaceUrl: true });
        }
        else{
          this.router.navigate(['/user/dashboard'], { replaceUrl: true });
        }
      }
      else{
        //debugger;
        // try{
        //   const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain().toPromise();
        // }
        // catch(e){
        //   console.error(e);
        // }
        this.router.navigate(['/site/schoolhome'], { replaceUrl: true });
      }
    
  }

}
